import { getDateTimeColumn, convertDate } from "./DateTimeValidation";

/**
 * AN ASSUMPTION IS BEING MADE THAT IF A VISIT IS ELECTIVE
 * IT IS VOID FOR ALL OTHER CODES, THEY WILL CHECK THAT AND AUTO FAIL CURRENTLY
 */
const weekdaysDaytime = [
    {
        code: 'B960',
        price: 36.4,
        applicable: false,
        name:'Weekdays Daytime Travel Premium',
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if(newApt.electiveHomeVisit){
                self.applicable = false;
                self.reason+='Not compatible with elective visit.\n';
                return;
            }
            if (!newApt.performedTravel) {
                self.applicable = false;
                self.reason += 'Travel not performed.\n';
                return;
            }
            let occurences = 0;
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (code == 'B960') occurences++;
                })
            })
            if (occurences >= 2) {
                self.applicable = false;
                self.reason += 'Maximum billing per cycle reached.'
            }
            self.applicable = true;
            self.reason = '';
        },
    },
    {
        code: 'B990',
        price: 27.5,
        name: 'First Person Seen Weekdays',
        applicable: false,
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if(newApt.electiveHomeVisit){
                self.applicable = false;
                self.reason+='Not compatible with elective visit.\n';
                return;
            }
            if (!newApt.firstPersonSeen) {
                self.applicable = false;
                self.reason = 'Patient was not first person seen.\n';
                return;
            }
            let occurences = 0;
            const codesThatCount = ['B990'];
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (codesThatCount.includes(code)) occurences++;
                })
            })
            if (occurences >= 10) {
                self.applicable = false;
                self.reason += 'Maximum billing per cycle reached.'
                return;
            }
            self.applicable = true;
            self.reason = '';
        }

    },
    
];

const weekdaysDaytimeSacrifice = [
    {
        code: 'B961',
        price: 36.4,
        applicable: false,
        reason: '',
        name: 'Travel Weekdays Sacrifice of Office Hours',
        validate({ self, newApt, timePeriodAppointments }) {
            if(newApt.electiveHomeVisit){
                self.applicable = false;
                self.reason+='Not compatible with elective visit.\n';
                return;
            }
            if (!newApt.performedTravel) {
                self.applicable = false;
                self.reason += 'Travel not performed.\n';
                return;
            }
            let occurences = 0;
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (code == 'B961') occurences++;
                })
            })
            if (occurences >= 2) {
                self.applicable = false;
                self.reason += 'Maximum billing per cycle reached.'
            }
            self.applicable = true;
            self.reason = '';
        },
    },
    {
        code: 'B992',
        price: 44,
        name: 'First Person Seen Weekdays Sacrifice of Hours',
        applicable: false,
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if(newApt.electiveHomeVisit){
                self.applicable = false;
                self.reason+='Not compatible with elective visit.\n';
                return;
            }
            if (!newApt.firstPersonSeen) {
                self.applicable = false;
                self.reason = 'Patient was not first person seen.\n';
                return;
            }
            let occurences = 0;
            const codesThatCount = ['B992'];
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (codesThatCount.includes(code)) occurences++;
                })
            })
            if (occurences >= 10) {
                self.applicable = false;
                self.reason += 'Maximum billing per cycle reached.'
                return;
            }
            self.applicable = true;
            self.reason = '';
        }

    },

];

const weekdaysEvening = [
    {
        code: 'B962',
        price: 36.4,
        applicable: false,
        name: 'Weekday Evening Travel',
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if(newApt.electiveHomeVisit){
                self.applicable = false;
                self.reason+='Not compatible with elective visit.\n';
                return;
            }
            if (!newApt.performedTravel) {
                self.applicable = false;
                self.reason += 'Travel not performed.\n';
                return;
            }
            let occurences = 0;
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (code == 'B962') occurences++;
                })
            })
            if (occurences >= 2) {
                self.applicable = false;
                self.reason += 'Maximum billing per cycle reached.'
            }
            self.applicable = true;
            self.reason = '';
        },
    },
    {
        code: 'B994',
        price: 66,
        name: 'First Person Seen Weekday Evenings',
        applicable: false,
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if(newApt.electiveHomeVisit){
                self.applicable = false;
                self.reason+='Not compatible with elective visit.\n';
                return;
            }
            if (!newApt.firstPersonSeen) {
                self.applicable = false;
                self.reason = 'Patient was not first person seen.\n';
                return;
            }
            let occurences = 0;
            const codesThatCount = ['B994'];
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (codesThatCount.includes(code)) occurences++;
                })
            })
            if (occurences >= 10) {
                self.applicable = false;
                self.reason += 'Maximum billing per cycle reached.'
                return;
            }
            self.applicable = true;
            self.reason = '';
        }
    },
];


const weekendOrHolidays = [
    {
        code: 'B963',
        price: 36.4,
        applicable: false,
        name: 'Weekend Daytime Travel',
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if(newApt.electiveHomeVisit){
                self.applicable = false;
                self.reason+='Not compatible with elective visit.\n';
                return;
            }
            if (!newApt.performedTravel) {
                self.applicable = false;
                self.reason += 'Travel not performed.\n';
                return;
            }
            let occurences = 0;
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (code == 'B963') occurences++;
                })
            })
            if (occurences >= 6) {
                self.applicable = false;
                self.reason += 'Maximum billing per cycle reached.'
            }
            self.applicable = true;
            self.reason = '';
        },
    },
    {
        code: 'B993',
        price: 82.5,
        name: 'First Person Seen Weekends',
        applicable: false,
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if(newApt.electiveHomeVisit){
                self.applicable = false;
                self.reason+='Not compatible with elective visit.\n';
                return;
            }
            const x = newApt
            if (!newApt.firstPersonSeen) {
                self.applicable = false;
                self.reason = 'Patient was not first person seen.\n';
                return;
            }
            let occurences = 0;
            const codesThatCount = ['B993'];
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (codesThatCount.includes(code)) occurences++;
                })
            })
            if (occurences >= 20) {
                self.applicable = false;
                self.reason += 'Maximum billing per cycle reached.'
                return;
            }
            self.applicable = true;
            self.reason = '';
        }

    },
];

const nights = [

    {
        code: 'B964',
        price: 36.4,
        applicable: false,
        name: 'Nightime Travel',
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if(newApt.electiveHomeVisit){
                self.applicable = false;
                self.reason+='Not compatible with elective visit.\n';
                return;
            }
            if (!newApt.performedTravel) {
                self.applicable = false;
                self.reason += 'Travel not performed.\n';
                return;
            }
            self.applicable = true;
            self.reason = '';
        },
    },
    {
        code: 'B996',
        price: 110,
        name: 'First Person Seen Nights',
        applicable: false,
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if(newApt.electiveHomeVisit){
                self.applicable = false;
                self.reason+='Not compatible with elective visit.\n';
                return;
            }
            if (!newApt.firstPersonSeen) {
                self.applicable = false;
                self.reason = 'Patient was not first person seen.\n';
                return;
            }
            self.applicable = true;
            self.reason = '';
        }

    },
];

const electiveHomeVisit = [
    {
        name:'Elective Home Visit Travel',
        price:36.4,
        code:'B960',
        applicable:false,
        reason:'',
        validate({self, newApt, timePeriodAppointments}){
            if(!newApt.performedTravel){
                self.applicable = false;
                self.reason += 'Physician did not travel.\n';
                return;
            }
            let occurences = 0;
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if(code == 'B960') occurences++;
                })
            })
            if(occurences>=2){
                self.applicable=false;
                self.reason+='Maximum billing per cycle reached.\n';
                return;
            }
            self.applicable = true;
            self.reason='';
        }
    },
    {
        name:'Elective Home Visit First Person Seen',
        price:27.5,
        code:'B990',
        applicable:false,
        reason:'',
        validate({self, newApt, timePeriodAppointments}){
            if(!newApt.firstPersonSeen){
                self.applicable = false;
                self.reason += 'Patient is not first seen.\n';
                return;
            }
            let occurences = 0;
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if(code == 'B990') occurences++;
                })
            })
            if(occurences>=10){
                self.applicable=false;
                self.reason+='Maximum billing per cycle reached.\n';
                return;
            }
            self.applicable = true;
            self.reason='';
        }
    }
];


export function getPatientHomeColumn(newApt) {
    const dateObject = convertDate(newApt.date, newApt.time);
    const columnType = getDateTimeColumn(dateObject);

    // ['weekdaysDaytime','weekdaysEvening', 'nights', 'weekendOrHoliday']
    if(newApt.electiveHomeVisit) return electiveHomeVisit; // check SOB pg 89, patient home has extra column, this is simple fix maintains form
    switch (columnType) {
        case 'weekdaysDaytime':
            if(newApt.sacrificeOfOfficeHours) return weekdaysDaytimeSacrifice;
            else return weekdaysDaytime;
        case 'weekdaysEvening':
            return weekdaysEvening;
        case 'nights':
            return nights;
        case 'weekendOrHoliday':
            return weekendOrHolidays;
    }
}

